import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store/index";
import echarts from "echarts";
import elementui from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "./assets/style/table.scss";
import "./assets/style/global.css";
import "./assets/style/global.scss";
import "./assets/style/element-variables.scss"; //改变主题颜色
import Moment from "moment";
import Vuex from "vuex";
import "./resgisterServiceWorker";
import VueAwesomeSwiper from "vue-awesome-swiper";

// import jquery from "jquery"
import constant from "./utils/constants.js";
import utils from "./utils/util.js";
import "./assets/font/font.css";
import "./assets/iconfont/iconfont.css";
import "./assets/iconfont/iconfont.js";
import "./assets/reset.css";
import "./assets/font/iconfont.css";
import "./assets/rem";
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
import gojs from 'gojs'
import clipboard from "clipboard";
import { loginController } from "@/api/activityController";
import {
  getSellerInfo,
} from "@/api/sellerController";
import VueVideoPlayer from 'vue-video-player'
import 'video.js/dist/video-js.css'
import 'vue-video-player/src/custom-theme.css'
import { checkPermisson } from "@/common/permission"
import common from './common/decrypt'
import commonOptimization from './common/commonOptimization'
// import JSEncrypt from "./utils/jsencrypt.min.js";
// const JSEncrypt = require('./utils/jsencrypt.min.js');
import JSEncrypt from 'jsencrypt/bin/jsencrypt.min'
import { uploadPointData } from "@/api/home.js"

Vue.prototype.clipboard = clipboard;
//图片拖动排序
import VueDND from "awe-dnd";

Vue.use(VueDND);
Vue.use(Viewer);
Vue.use(VueVideoPlayer);

import VueClipboard from 'vue-clipboard2'

Vue.use(VueClipboard);

/***************引入gojs为原型函数*************************************/
Vue.prototype.$go = gojs
Vue.prototype.$make = gojs.GraphObject.make

// 全局京豆总数判断三个必填项 row.quantityTotal京豆总数   row.price京豆单个奖励  row.prizeCount填写的京豆总份数额
// Vue.prototype.$jingdouTotal = (row) => {
//   if (row.quantityTotal && row.prizeCount && Number(row.prizeCount) * Number(row.price) > row.quantityTotal) {
//     return "";
//   } else {
//     return row.prizeCount;
//   }
// }
Vue.prototype.$jingdouTotal = commonOptimization.jingdouTotal
Vue.prototype.$getDate = commonOptimization.getDate

//el-input挂载
import onlyNumber from "@/directive/el-input"; //添加此行=>自定义全局指令

Vue.use(onlyNumber); //添加此行=>使用该全局指令

Vue.use(Vuex);

Vue.use(Moment);
Vue.use(elementui, { size: "small", zIndex: 3000 });
Vue.use(echarts);
Vue.use(VueAwesomeSwiper /* { default global options } */);
Vue.use(constant);
Vue.use(utils);

// Vue.prototype.jq = jquery
// 双击解密
Vue.prototype.$decrypt = common;



Vue.prototype.moment = Moment;

Vue.prototype.$echarts = echarts;

Vue.prototype.$myVue = Vue;

Vue.config.productionTip = false;

Vue.prototype.bus = new Vue();

Vue.directive('preventReClick', {
  inserted(el, binding) {
    el.addEventListener('click', () => {
      if (!el.disabled) {
        el.disabled = true
        setTimeout(() => {
          el.disabled = false
        }, binding.value || 3000)
      }
    })
  }
})

Vue.directive('permissions', {
  inserted: function (el, binding) {
    const permissions = JSON.parse(sessionStorage.getItem("permissions")) || []
    if (permissions.indexOf(binding.value) != -1) {
      el.style.display = "inline-block"
    } else {
      el.style.display = "none"
    }
  }
})

let maidian = (value) => {
  if (window._hmt) {
    window._hmt.push(['_trackEvent', '按钮点击', 'click', `${value.from}-${value.name}`]);
  }
}
// 按钮埋点
Vue.directive('zoom', {
  inserted(el, binding) {
    el.onclick = () => maidian(binding.value)
  },

  update(el, binding) {
    let old = binding.oldValue.from
    let newV = binding.value.from
    if (old != newV) {
      el.onclick = false
      el.onclick = () => maidian(binding.value)
    }

  }
})
// 标签埋点
Vue.directive('labelZoom', {
  inserted(el, binding) {
    el.addEventListener('click', () => {
      if (window._hmt) {
        window._hmt.push(['_trackEvent', '标签选择', 'active', `${binding.value.name}`]);
      }
    })
  }
})


// 定时器标识
let timer = null
let timeEnter = null
let times = 0
// 埋点计时器
Vue.prototype.setIntervalFun = async function (name, firstClassify, secondClassify, id) {
  if (!id) return
  timer = setTimeout(() => {
    times = times + 1
    // 页面停留超过1小时，停止埋点
    if (times >= 3600) {
      this.clearBuriedPoint()
      return
    }
    this.buriedPointTimes(name, firstClassify, secondClassify, id)
  }, 2000)
}
// 清除埋点
Vue.prototype.clearBuriedPoint = function () {
  clearTimeout(timer)
}
let route
// 页面埋点
Vue.prototype.buriedPoint = async function (action, firstClassify, secondClassify, name) {
  let flage = false
  if (!flage) {
    this.clearBuriedPoint()
    clearTimeout(timeEnter)
    flage = true
  }
  if (flage) {
    setTimeout(async () => {
      times = 0
      var route = this.$route.path
      let params = {
        platform: 'tb',
        venderId: '',
        shopTitle: '',
        source: 0,//来源 0:pc端 1:移动端
        action: action,//类型 1进入页面 2点击按钮 3授权进入 4操作
        url: route,// 路径
        name: name,//"页面/按钮名称（1、2类型时要有）",
        sign: encryptMI(),//JSE加密
        firstClassify: firstClassify, // 一级分类
        secondClassify: secondClassify, // 二级分类
      }
      // 当前店铺信息
      let { data: userInfo } = await getSellerInfo()
      // 当前店铺信息
      params.venderId = userInfo.sellerId
      params.shopTitle = userInfo.shopTitle
      // 调用埋点
      let res = await uploadPointData(params)
      if (res.code) {
        this.buriedPointTimes(name, firstClassify, secondClassify, res.data)
      }
    }, 500)
  }
}

// 轮询埋点
Vue.prototype.buriedPointTimes = async function (name, firstClassify, secondClassify, id) {
  var route = this.$route.path
  let params = {
    platform: 'tb',
    venderId: '',
    shopTitle: '',
    source: 0,//来源 0:pc端 1:移动端
    action: 5,//类型 1进入页面 2点击按钮 3授权进入 4操作
    url: route,// 路径
    name: name,//"页面/按钮名称（1、2类型时要有）",
    sign: encryptMI(),//JSE加密
    firstClassify: firstClassify, // 一级分类
    secondClassify: secondClassify, // 二级分类
    requestId: id // 请求id
  }
  params.venderId = this.$store.state.loginUserInfo.venderId
  params.shopTitle = this.$store.state.loginUserInfo.sellerPin
  // 调用埋点
  let res = await uploadPointData(params)
  // 轮询-埋点
  this.clearBuriedPoint()
  this.setIntervalFun(name, firstClassify, secondClassify, id)
}

// JSEncrypt加密
const encryptMI = function (origin = Date.now()) {
  // 公钥
  const key = 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDa+vHCmfKZxVdMBbp69Stu4u11BlOqfEDXK8HqZJ8dKHArYd+78wMzvpQZcWFtdix8MYaTLQERIaxjRoLrGYvYiONi+dKaZ/SSAI8boATYb1Wimz/ocUIGGj2SSZwQ6l5xzOu7orKVdrzUMpqETbuxRwAeMe1ZP/YQ20aXmmGBgwIDAQAB';
  let encrypt = new JSEncrypt();
  encrypt.setPublicKey(key)
  return encrypt.encrypt(origin + '')
}

//百度统计代码
var _hmt = _hmt || [];
window._hmt = _hmt;
(function () {
  var hm = document.createElement("script");
  hm.src = hm.src = "https://hm.baidu.com/hm.js?68e65e77b10e09e3bff6192dcf88de08";
  var s = document.getElementsByTagName("script")[0];
  s.parentNode.insertBefore(hm, s);
})();

router.onError((error) => {
  const pattern = /Loading chunk (\d)+ failed/g;
  const isChunkLoadFailed = error.message.match(pattern);
  const targetPath = router.history.pending.fullPath;
  if (isChunkLoadFailed) {
    router.replace(targetPath);
  }
});
router.beforeEach((to, from, next) => {
  if (to.path.indexOf('IntegralEquity') > -1) {
    window.open("https://ecrm.taobao.com/jxt/jxtHomepage.htm?#//tbpassport.taobao.com/member/benefit", "_blank");
    next({
      path: from.path,                //无登录状态,先跳转到登录页面
    })
  } else if (to.path.indexOf('assetItemManage') > -1) {
    // 埋点
    // this.buriedPoint(1, "云起互动", "资产项设置", "资产项设置");
    window.open("https://fuwu.taobao.com/ser/miniAppUse.htm?articleCode=FW_GOODS-1001212154#/", "_blank");
    next({
      path: from.path,                //无登录状态,先跳转到登录页面
    })
  } else {
    const permission = checkPermisson(to.path, to.query)
    if (permission) {
      next()
    } else {
      next("/nopermission");
    }
  }

});
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
